import "../App.css"
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState, useEffect, Component } from "react";
import "../style.css"
import "../w3.css"
import MasterMap  from "./masterMap"
import pdf from '../img/user_manual.pdf'
import doc from '../img/document.pdf'
import sample from '../img/sample_files.zip'




class LeftPanel extends Component {
    
    state={
        // colors:[{
        // "Agro-horticulture":"#006400",
        // "Agro-forestry":"#fcf31c",
        // "Horticulture":'#b90400',
        // "Silvipasture":"#842b00",
        // },
        // {"Grazing/Pasture Land":"#b2d718",
        // "Production Forestry":"#ffaeb0",
        // "Afforestation":"#ca8544",
        // "Reclamation of Wasteland":"#eb85ff",
        // "Aquaculture":"#3069fe",
        // },
        // {"Recreational / Industrial":"#ca8544",
        // "Contour Trenches":"#b2d718",
        // "Earthen Contour Bunds":"#fff978",
        // "Loose Boulder Check Dam / Gully Plugs":"#006400",
        // "Gabion Structures":"#51be41",
        // },
        // {"Earthen Dams (Nala bund)":"#73cb07",
        // "Percolation Tank":"#faccab",
        // "Minor Irrigation Tanks (Surface Water)":"#e60000",
        // "Farm Ponds":"#4ce7a5",
        // "Subsurface Dykes (across channel bed)":"#b2d718",
        // "Arable Areas (Khadins)":"#cb96e5"}],
        showLegend:false
    }   
    //     colors:[{"Core Urban":"#fa0202",
    //     "Peri-Urban":"#b90400",
    //     "Other Urban Areas":"#842b00",
    //     "Village Settlement":"#e60000",
    //     "Mixed Village Settlement":"#f34429",
    //     "Hamlet & Dispersed Household":"#ffaeb0",
    //     "Other Rural Built-up Areas":"#ff807a",
    //     "Industrial area":"#ca8544",
    //     "Transport Network":"#d35563",
    //     "Transport Infrastructure":"#46505a"},
    //     {"Crop Land":"#fff978",
    //     "Fallow Land":"#faccab",
    //     "Agriculture Plantation / Orchards":"#fcf31c",
    //     "Aquaculture":"#3069fe",
    //     "Closed Forest":"#006400",
    //     "Open Forest":"#51be41",
    //     "Forest Plantation":"#73cb07",
    //     "Swamp area / Mangrove":"#4ce7a5",
    //     "Grasslands / Grazing Lands":"#b2d718",
    //     "Salt Affected Land":"#e8abf9"},
    //     {"Gullied land":"#cf0cfc",
    //     "Ravinous Land":"#e30cf5",
    //     "Dense scrub land":"#fb36ff",
    //     "Sparse scrub land":"#c734c0",
    //     "Barren Rocky":"#ff99ff",
    //     "Stony Waste":"#eb85ff",
    //     "Sandy area - Desertic":"#fac846",
    //     "Sandy area - Coastal":"#e4cdff",
    //     "Waterlogged":"#03979b",
    //     "River":"#0430cd"},
    //     {"Stream":"#0e41cd",
    //     "Canal / Drain":"#2a33f2",
    //     "Lakes / Pond":"#5f99ff",
    //     "Reservoirs / Tank":"#319af5",
    //     "Snow covered area":"#cccccc",
    //     "Glacial area":"#c8ffff",
    //     "Shifting Cultivation area":"#d98ad9",
    //     "Mining / Quarry / Mining Dump":"#caad30",
    //     "Rann":"#e0e6fc",
    //     "Salt pan":"#cb96e5",
    //     "Other":"#000000"}],
    //     showLegend:false
    // }   
    
      
    render(){
return(
<div className="content_div">
<div style={{display:'flex',flexDirection:'column',justifyContent:'center'}}>
<div className="card" onClick= {(e) => { this.props.setMenu("LRD")}}>
<div className="card_image"><img src={require('../img/LRDP.jpg')} style={{width:'100%',height:'100%',padding:5}} alt="LRDP"/></div>
<div class="card_title" style={{padding:5,fontSize:25}}> <p>Land Resource Development Planning (LRDP)</p></div>
</div>
<div className="card"  onClick= {(e) => { this.props.setMenu("WRD")}}>
<div className="card_image"><img src={require('../img/WRDP.jpg')} style={{width:'100%',height:'100%',padding:5}} alt="WRDP"/></div>
<div class="card_title" style={{padding:5,fontSize:25}}> <p>Water Resource Development Planning (WRDP)</p></div>
</div>
<div className="card" style={{cursor:'default'}}>
<div className="card_image"><img src={require('../img/pdf-icon.png')} style={{padding:5}} alt="User Manual"/></div>
<div style={{display:'flex',flexDirection:'column',justifyContent:'center'}}>
    <a  class="card_title" onClick= {(e) => {window.open(pdf)}} style={{padding:5,fontSize:20,textDecoration:'none',cursor:'pointer'}}> <span>User Manual</span></a>
    <a class="card_title" onClick= {(e) => {window.open(doc)}} style={{padding:5,fontSize:20,textDecoration:'none',cursor:'pointer'}}> <span>Document for Land & Water Resources Development Planning under SISDP-Update project</span></a>
</div>
{/* <button type="button"  value="User Manual"><img src={require("../img/pdf_icon.png")}></img>User Manual</button> */}
</div>


<div className="card"  onClick= {(e) => {window.open(sample)}}>
<div className="card_image"><img src={require('../img/downloads.png')} style={{width:'50%',padding:5}} alt="User Manual"/></div>
<div class="card_title" style={{padding:5,fontSize:20}}> <span>Download Sample Shape Files</span></div>
{/* <button type="button"  value="Download Sample Shape Files."  style={{margin:10,width:500,height:100,borderWidth:0,backgroundColor:'#ffffff',alignSelf:'center'}}><img src={require("../img/downloads.png")} width={32} height={32}></img>Download Sample Shape Files</button> */}

</div>
<br></br>

{/* <div style={{display:'flex',flexDirection:'row',cursor:'pointer',width:'max-content'}}  onClick={()=>this.setState({showLegend:!this.state.showLegend})}>
{!this.state.showLegend?
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret--fil" style={{alignSelf:'center',cursor:'pointer'}} viewBox="0 0 16 16">
  <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
</svg>:
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" style={{alignSelf:'center',cursor:'pointer'}} viewBox="0 0 16 16">
  <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
</svg>}
<h5 style={{alignSelf:'center',margin:0,cursor:'pointer',color:'#e96405'}}>Legends</h5>
</div>
{this.state.showLegend?
<div className="legends" style={{display:'flex',flexDirection:'row'}}>

 <table style={{fontSize:11,textAlign:'left'}}>
       {Object.entries(this.state.colors[0]).map(([key,value])=>{
        return(
        <>
        <tr>
            <td>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start'}}>
                    <div class='box red' style={{backgroundColor:value}}>                
                    </div>
                    <span style={{paddingLeft:5}}>{key}</span>
                </div>
            </td>            
        </tr> 
        </>       
        )})
    }    
</table> 
<table style={{fontSize:11,textAlign:'left'}}>
       {Object.entries(this.state.colors[1]).map(([key,value])=>{
        return(
            <>
            <tr>
            <td>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start'}}>
                    <div class='box red' style={{backgroundColor:value}}>                
                    </div>
                    <span style={{paddingLeft:5}}>{key}</span>
                </div>
            </td>
            
        </tr> 
        </>       
        )})
    }    
</table>
<table style={{fontSize:11,textAlign:'left'}}>
       {Object.entries(this.state.colors[2]).map(([key,value])=>{
        return(
            <>
            <tr>
            <td>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start'}}>
                    <div class='box red' style={{backgroundColor:value}}>                
                    </div>
                    <span style={{paddingLeft:5}}>{key}</span>
                </div>
            </td>
            
        </tr> 
        </>       
        )})
    }    
</table>
<table style={{fontSize:11,textAlign:'left'}}>
       {Object.entries(this.state.colors[3]).map(([key,value])=>{
        return(
            <>
            <tr>
            <td>
                <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-start'}}>
                    <div class='box red' style={{backgroundColor:value}}>                
                    </div>
                    <span style={{paddingLeft:5}}>{key}</span>
                </div>
            </td>
            
        </tr> 
        </>       
        )})
    }    
</table>

 
</div>:null} */}
</div>
<MasterMap    id="map"
            //   key={Math.random()} 
              results={this.props.results}
              resData={this.props.resData}
              mainMenu={this.props.mainMenu}
              handleCapture={this.props.handleCapture}
              colors={this.props.colors}    
/>    
  
</div>
)
}
}
export default LeftPanel